import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Avatar from 'shopper/components/Avatar';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { toStoreImageAltText } from 'lib/image';

const PublishDetails = ({
  className,
  storeDomain,
  storeImage = null,
  storeName = null,
}) => (
  <div className={twJoin('flex items-center justify-between', className)}>
    <div className="flex items-center gap-x-2">
      <Avatar
        description={toStoreImageAltText(storeName)}
        icon="store"
        size="size6"
        src={storeImage}
      />
      <Text
        as="span"
        className="text-sm font-regular leading-4 text-neutral-low-500 dark:text-neutral-high-200"
        size="size3"
      >
        Vendido por:{' '}
        <Text
          as="span"
          className="text-sm font-bold leading-4 text-neutral-low-500 dark:text-neutral-high-100"
          size="size3"
        >
          {storeName || storeDomain}
        </Text>
      </Text>
      {storeDomain && <Icon name="verified-color" size="size4" />}
    </div>
  </div>
);

PublishDetails.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  storeDomain: PropTypes.string.isRequired,
  storeImage: PropTypes.string,
  storeName: PropTypes.string,
};

export default PublishDetails;
